export default class NotificationsClient {
    constructor(apiClient) {
        this.notificationsUrl = '/v3/push_notifier';
        this.apiClient = apiClient;
        this.postUserAuthentication = this.postUserAuthentication.bind(this);
        this.postChannelAuthorization = this.postChannelAuthorization.bind(this);
        this.postTrigger = this.postTrigger.bind(this);
    }
    postUserAuthentication(data, config) {
        return this.apiClient.post(`${this.notificationsUrl}/user_auth`, data, config);
    }
    postChannelAuthorization(data, config) {
        return this.apiClient.post(`${this.notificationsUrl}/channel_auth`, data, config);
    }
    postTrigger(channelId, data, config) {
        return this.apiClient.post(`${this.notificationsUrl}/${channelId}/trigger`, data, config);
    }
}
